import { API_URL, BASE_URL } from '../../App';
import TeamCard from '../Components/TeamCard';
import './styles/OurTeam.scss';

function OurTeam(props) {
    const {
        data,
        categori,
        tag
    } = props;

    const teamRender = () => {
        if (data) {
            return (
                data.map((team, i) => {
                    const attributes = team.attributes;

                    return (
                        <TeamCard
                            key={i}
                            name={attributes.Name}
                            role={attributes.Title}
                            picture={attributes.Profile_ID}
                            bio={attributes.Description}
                            twitter={attributes.Twitter}
                            linkedin={attributes.Linkedin}
                            />
                    )
                })
            )
        }
    }

    return (
    <section className={categori}>
        <div className="teamLeftColumn">
            <div className='leftColumnTextContainer'>
                <p className="subtitle">{tag}</p>
                <h2 className="teamTitle">{props.children}</h2>
            </div>
        </div>
        <div className='teamCardsContainer'>
            {teamRender()}
        </div>
    </section>
     
    )
}

export default OurTeam;